// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__35CHw","dragIcon":"SortableItem_dragIcon__fwqk1","disabled":"SortableItem_disabled__zie7M"};